const ARREARS_LIST = "ARREARS_LIST";
const state = {
  arrearsList: [],
};
const actions = {
  setArrearsList({ commit }, arrear) {
    console.log("arrear=>", arrear);
    commit(ARREARS_LIST, arrear);
  },
};
const mutations = {
  [ARREARS_LIST](state, arrear) {
    const arrearsList = [...state.arrearsList];
    if (arrearsList.length > 10) arrearsList.shift();
    state.arrearsList = [...arrearsList, arrear];
  },
};
export const arrearsInformation = {
  namespaced: true,
  state,
  actions,
  mutations,
};
